export const cardsData = [
  {
    id: 'audit-planning',
    title: 'Audit Planning',
    description: 'Plan your audits effectively with guided steps and sample templates.',
  },
  {
    id: 'audit-fieldwork',
    title: 'Audit Fieldwork',
    description: 'Learn how to conduct fieldwork and collect evidence with best practices.',
  },
  {
    id: 'audit-reporting',
    title: 'Audit Reporting',
    description: 'Discover the process of preparing and finalizing audit reports.',
  },
];
